import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';
import './CustomCancelButton.scss';

export const CancelButton = React.forwardRef<HTMLButtonElement, ButtonProps>(function CancelButton(
  { className, ...props },
  ref
) {
  const rootClass = className ? `cancel-button ${className}` : 'cancel-button';
  return <Button ref={ref} className={rootClass} {...props} />;
});

CancelButton.displayName = 'CancelButton';
